import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  return <AnimatePresence data-id="element-146">
      {isOpen && <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-id="element-147">
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.2
      }} className="absolute inset-0 bg-navy-dark/80 backdrop-blur-sm" onClick={onClose} data-id="element-148" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.3
      }} className="relative bg-cream rounded-2xl shadow-2xl w-full max-w-2xl max-h-[80vh] flex flex-col overflow-hidden border border-gold/10" data-id="element-149">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-navy/10 shrink-0" data-id="element-150">
              <h2 className="text-2xl font-serif font-bold text-navy" data-id="element-151">
                {title}
              </h2>
              <button onClick={onClose} className="p-2 rounded-full hover:bg-navy/5 transition-colors cursor-pointer" aria-label="Cerrar" data-id="element-152">
                <XIcon className="w-5 h-5 text-navy/60" data-id="element-153" />
              </button>
            </div>

            {/* Content */}
            <div className="p-6 overflow-y-auto text-navy/80 leading-relaxed space-y-4 text-sm" data-id="element-154">
              {children}
            </div>
          </motion.div>
        </div>}
    </AnimatePresence>;
}